import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import LotSelect from "../ui/lotSelect";
import './ThamSoTheoLoaiCuoc.scss'
type OwnProps = {
    dai: string;
    group: string;// 2C,3C,4C,Da
    parentState: any,
    onUpdateParam: (param: any) => void;
    canChuyenParam: any;
}

const ThamSoDa: FC<OwnProps> = ({
    parentState,
    dai,
    group,
    onUpdateParam,
    canChuyenParam,
}) => {
    const [state, setState] = useState({

    })
    const cc = canChuyenParam
    function handleParamChange(subGroup: string, value: number | string, field: string) {
        const payload = { dai: dai, group: group, subGroup: subGroup, value: value, field: field }
        if (typeof value == 'number' && isNaN(value))
            payload.value = 0
        onUpdateParam(payload)
        console.log(payload)
    }
    if (!cc[dai])
        return <></>
    if (!cc[dai]["Da"]) {
        return <></>
    }
    return (
        <>
            <div className="lot-title">{dai}</div>
            <div className="tsd-grid">
                <div>Da</div>
                <LotSelect value={cc[dai]["Da"].kieuGiu}
                    onChange={(e) => { handleParamChange("Da", e.target.value, "kieuGiu") }}
                    id="l-kieu-giu-dau">
                    <option value={"DIEM"} selected={cc[dai]["Da"].kieuGiu == "DIEM"}>Giữ theo điểm</option>
                    <option value={"PT"} selected={cc[dai]["Da"].kieuGiu == "PT"}>Giữ theo %</option>
                </LotSelect>
                <input value={cc[dai]["Da"].diemGiu} onChange={(e) => { handleParamChange("Da", Number(e.target.value), "diemGiu") }}></input>
            </div>

        </>
    )
}
export default memo(ThamSoDa)